import { TextField, type TextFieldProps } from "@mui/material";
import { type FC } from "react";
import { type CustomRepeatType } from "../hooks/use-number-of-repeats";

type CustomRepeatEveryProps = Omit<TextFieldProps, "onChange" | "value"> & {
  value: CustomRepeatType["every"];
  onChange: (value: CustomRepeatType["every"]) => void;
};

export const CustomRepeatEvery: FC<CustomRepeatEveryProps> = ({ value, onChange, ...props }) => {
  return (
    <TextField
      label="Every"
      type="number"
      value={value}
      onChange={(e) => {
        const val = parseInt(e.target.value, 10);
        onChange(val);
      }}
      sx={{ maxWidth: 90 }}
      {...props}
    />
  );
};
